import React from "react";
import { PageHero } from "../components/PageShells";

const brands = [
  { name: "Tesla Powerwall", desc: "Wereldwijde marktleider. Geïntegreerde omvormer, premium app en stormbeveiliging." },
  { name: "BYD Battery-Box", desc: "Modulair LFP-systeem van 's werelds grootste batterijproducent. Schaalbaar tot 22 kWh." },
  { name: "Huawei Luna2000", desc: "Hoog vermogen, intelligente energieverdeling en uitstekende prijs/kwaliteit verhouding." },
  { name: "Sigenergy SigenStor", desc: "Innovatieve all-in-one systemen met EV-lader integratie en AI-optimalisatie." },
  { name: "Sonnen sonnenBatterie", desc: "Duitse kwaliteit, hoogwaardige LFP cellen, 10.000 cycli garantie." },
  { name: "Enphase IQ Battery", desc: "Micro-inverter technologie, modulair vanaf 3.5 kWh, eenvoudige uitbreiding." },
  { name: "SolarEdge Home Battery", desc: "Perfecte integratie met SolarEdge omvormers, hoge laadsnelheid." },
];

const Merken = () => (
  <main data-testid="brands-page">
    <PageHero
      eyebrow="Premium merken"
      title="De beste batterijmerken, onafhankelijk geadviseerd."
      subtitle="Wij zijn merkonafhankelijk en kiezen samen met jou de oplossing die het best past."
    />
    <section className="section-pad bg-slate-50/70">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 gap-5">
        {brands.map((b) => (
          <div key={b.name} className="bg-white rounded-3xl border border-slate-200 p-7 hover:border-brand/40 transition-all">
            <h3 className="font-heading text-2xl font-black text-navy-900 mb-2">{b.name}</h3>
            <p className="text-slate-600 leading-relaxed">{b.desc}</p>
          </div>
        ))}
      </div>
    </section>
  </main>
);

export default Merken;
